import { createContext } from "react";
const MotionConfigContext = createContext({
  transformPagePoint: (p) => p,
  isStatic: false,
  reducedMotion: "never"
});
export {
  MotionConfigContext
};
//# sourceMappingURL=MotionConfigContext.js.map
